import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="pt-40 container-w mono-label">Loading…</div>;
  if (!user || !user.is_admin) return <Navigate to="/login" replace />;
  return children;
}
